import { render } from "./index.vue?vue&type=template&id=ffa300e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ffa300e0&lang=css"
import "./index.vue?vue&type=style&index=1&id=ffa300e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa300e0"]])

export default __exports__